<template>
  <div class="height1">
    <bread></bread>
    <div class="center-content">
      <div class="iq-card-body">
        <!-- <div class="table-top">
          <div class="iq-search-bar">
            <el-form :model="searchForm" :inline="true">
              <el-form-item>
                <el-date-picker v-model="searchForm.datepicker" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions0" size="small" style="margin-right: 10px; width: 260px" @change="Search" clearable> </el-date-picker>
              </el-form-item>
              <el-form-item label="部门">
                <el-cascader :options="departmentData" :props="{ expandTrigger: 'hover', checkStrictly: true, value: 'id', label: 'name', children: 'childrens' }" :clearable="true" style="width: 100%" filterable @change="handleOption" size="small"></el-cascader>
              </el-form-item>
              <el-form-item label="">
                <el-input v-model="searchForm.keyWord" type="text" size="small" placeholder="订单号/接诊医生/联系方式" @keyup.enter.native="Search"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="Search()">搜索</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div> -->
        <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="{ background: '#F5F7FC' }" height="calc(100% - 0px)" row-key="departmentId" :tree-props="{ children: 'childrens', hasChildren: 'childrens.length>0' }">
          <el-table-column type="index" label="编号" width="50"></el-table-column>
          <el-table-column prop="businessName" label="业务员名称"></el-table-column>
          <el-table-column prop="departmentName" label="所属业务组" align="center"></el-table-column>
          <el-table-column prop="userBindNum" label="绑定医生" align="center">
            <template slot-scope="scope">
              <el-link type="primary" @click="showUserBindNumBtn(scope.row)" v-if="scope.row.userBindNum>0">{{ scope.row.userBindNum }}</el-link>
              <span v-else>{{ scope.row.userBindNum }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="userMZNum" label="订单数" align="center"></el-table-column>
          <el-table-column prop="userPayMoney" label="订单总额(元)" align="center">
            <template slot-scope="scope">
              {{ scope.row.userPayMoney.toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="150px">
            <template slot-scope="scope">
              <span class="primary optionBtn" @click="prviewBtn(scope.row)">明细</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--    查看    -->
    <el-dialog :visible.sync="infoDialog" width="55%">
      <el-table :data="infoData" stripe style="width: 100%" height="440px">
        <el-table-column type="index" label="编号" width="50"></el-table-column>
        <el-table-column prop="userName" label="姓名"/>
        <el-table-column prop="account" label="账号" align="center" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { Outpatient } from '@/components/DrugDomain/Outpatient.js'
import { Department } from '@/components/HospitalDomain/Department.js'
import { User } from "@/components/HospitalDomain/User.js";
import { Distributor } from "@/components/HospitalDomain/Distributor.js";
export default {
  data() {
    var outpatient = new Outpatient(this.TokenClient, this.Services.Drug)
    var department = new Department(this.TokenClient, this.Services.Authorization)
    var user = new User(this.TokenClient, this.Services.Authorization);
    var distributor = new Distributor(this.TokenClient, this.Services.Authorization);
    return {
      OutpatientDomain: outpatient,
      Department: department,
      DistributorDomain: distributor,
      User: user,
      tableData: [],
      pageIndex: 1,
      dataTotal: 1,
      pageSize: 0,
      departmentData: [],
      departmentUsersData: [],
      searchForm: {
        keyWord: '',
        datepicker: '',
        departmentId: 0,
      },
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
      infoDialog: false,
      infoData: [],
      userData:[],
    }
  },
  mounted() {
    this.getDepartmentUsers()
  },
  methods: {
    herbalSearch() {
      var _this = this;
      let organizationId = JSON.parse(sessionStorage.getItem('userInfo')).organizationId
      _this.userData = [];
      return new Promise((resolve, reject) => {
        _this.User.GetUserAll(
          organizationId,
          async function (data) {
            resolve(data.data);
          },
          function (error) {
            console.log(error);
            resolve([]);
          }
        );
      });
    },
    async showUserBindNumBtn(item) {
      this.infoData = [];
      let data = await this.herbalSearch();
      if (data && data.length > 0) {
        this.usersData = data;
        let userBindIds = await this.getBindingUserIds(item.businessId);
        userBindIds.forEach((item) => {
          let list =data.filter((i) => i.id == item);
          if (list.length > 0) {
            this.infoData.push(list[0]);
          }
        });
        this.infoDialog = true;
      }
    },
    getBindingUserIds(userId) {
      let organizationId = JSON.parse(sessionStorage.getItem('userInfo')).organizationId
      var _this = this;
      return new Promise((resolve, reject) => {
        _this.DistributorDomain.GetBusinessBandUser(
          organizationId,
          userId,
          function (data) {
            resolve(data.data.userBindIds);
          },
          function (error) {
            console.log(error);
            resolve([]);
          }
        );
      });
    },
    prviewBtn(item) {
      sessionStorage.setItem('bindUsers', JSON.stringify([item]))
      this.$router.push({
        path: './BindUsersMZStats'
      })
    },
    getDepartment() {
      let organizationId = JSON.parse(sessionStorage.getItem('userInfo')).organizationId
      var _this = this
      _this.Department.GetDepartment(
        organizationId,
        function (data) {
          _this.departmentData = data.data
        },
        function (err) {
          _this.departmentData = []
        }
      )
    },
    getDepartmentUsers() {
      var _this = this
      _this.Department.GetDepartmentUsersTree(
        false,
        function (data) {
          _this.departmentUsersData = data.data
          _this.getList()
        },
        function (err) {
          _this.departmentUsersData = []
        }
      )
    },
    changePage(pageIndex) {
      this.pageIndex = pageIndex
      this.getList()
    },
    getList() {
      var _this = this
      let organizationId = JSON.parse(sessionStorage.getItem('userInfo')).organizationId
      _this.tableData = []
      var item = _this.searchForm
      if (_this.searchForm.datepicker) {
        item.startTime = _this.searchForm.datepicker[0] + ' 00:00:00'
        item.endTime = _this.searchForm.datepicker[1] + ' 23:59:59'
      } else {
        item.startTime = ''
        item.endTime = ''
      }
      _this.OutpatientDomain.BusinessMZInputInfo(
        _this.departmentUsersData,
        organizationId,
        item.departmentId,
        item.startTime,
        item.endTime,
        function (data) {
          _this.tableData = data.data
        },
        function (err) {
          console.log(err)
        }
      )
    },
    Search(event) {
      this.getList()
    },
  },
}
</script>

<style scoped>
.dialog-form {
  width: 85%;
}
</style>
